import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-merge-pdf',
    imports: [],
    templateUrl: './blog-merge-pdf.component.html',
    styleUrl: './blog-merge-pdf.component.css'
})
export class BlogMergePdfComponent {

}
